import { Heading, StackletLogo } from "@stacklet/ui";

/** Props for AuthScreenLayout */
interface Props {
  /** Large heading at the top of the panel. */
  title: string;
  /** Supporting line beneath the title. */
  subtitle: string;
  /** Form/content rendered below the header. */
  children: React.ReactNode;
}

/**
 * Shared frame for the unauthenticated screens (sign-in, reset password): a
 * centered panel with the Stacklet logo, a title, and a subtitle.
 */
export function AuthScreenLayout({ title, subtitle, children }: Props) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-overlay-medium px-2xl">
      <div className="flex w-full max-w-md flex-col gap-2xl">
        <StackletLogo className="stacklet-logo h-3xl w-auto self-start text-brand-primary" />

        <div className="flex flex-col gap-xs">
          <Heading
            className="whitespace-nowrap text-display-small font-semibold"
            level={1}
          >
            {title}
          </Heading>
          <p className="text-body-medium text-text-secondary">{subtitle}</p>
        </div>

        {children}
      </div>
    </div>
  );
}
